import { section } from './rows';
import { formatMeasure } from './units';

/** Live: what the vehicle is doing right now — event, motion, distances, environment, time. */
export const liveSections = (view, ctx) => {
	const { t } = ctx;
	const label = (key) => t(`oemDataModal_cerebrumx_live_${key}`);
	const yesNo = (value) => {
		if (value === undefined) return undefined;
		return t(value ? 'oemDataModal_yes' : 'oemDataModal_no');
	};
	// GPS speed is served unitless; it shares the OBD speed's unit (same payload).
	const speedGps = view.speedGps && { ...view.speedGps, unit: view.speedGps.unit ?? view.speed?.unit };
	// Trip distance is served unitless; it shares the odometer's unit.
	const tripDistance = view.tripDistance === undefined
		? undefined
		: { value: view.tripDistance, unit: view.odometer?.unit };

	return [
		section('live', [
			{ key: 'eventType', icon: 'warning', label: label('eventType'), value: view.eventType },
			{ key: 'moving', icon: 'timeline', label: label('moving'), value: yesNo(view.moving) },
			{ key: 'gear', icon: 'settings', label: label('gear'), value: view.gear?.toUpperCase() },
			{ key: 'speed', icon: 'speed', label: label('speed'), value: formatMeasure(view.speed, ctx) },
			{ key: 'speedGps', icon: 'speed', label: label('speedGps'), value: formatMeasure(speedGps, ctx) },
			{
				key: 'acceleration',
				icon: 'timeline',
				label: label('acceleration'),
				value: formatMeasure(view.acceleration, ctx),
			},
			{
				key: 'lateralAcceleration',
				icon: 'timeline',
				label: label('lateralAcceleration'),
				value: formatMeasure(view.lateralAcceleration, ctx),
			},
			{ key: 'odometer', icon: 'speed', label: label('odometer'), value: formatMeasure(view.odometer, ctx) },
			{
				key: 'tripDistance',
				icon: 'route',
				label: label('tripDistance'),
				value: formatMeasure(tripDistance, ctx),
			},
			{
				key: 'ambientTemperature',
				icon: 'thermostat',
				label: label('ambientTemperature'),
				value: formatMeasure(view.ambientTemperature, ctx),
			},
			{
				key: 'lastReported',
				icon: 'schedule',
				label: label('lastReported'),
				value: view.eventTime && ctx.formatDateTime(view.eventTime),
			},
		]),
	];
};
